<icz-card class="icz-body-1">
  <div class="row-group items-center">
    <div class="object-icon">
      <icz-icon svgIcon="prirucni_registratury" class="mr-8" [withCustomIconColor]="true" size="small"></icz-icon>
    </div>
    <div>
      <span class="mr-4 ml-16">{{ heading }}</span>
      @if (!isFileCabinetInfoUnavailable && fileCabinetInfo) {
        <a class="p-4" iczLinkWithoutHref (click)="openFileCabinetTable(fileCabinetInfo!)">
          {{ fileCabinetInfo!.name }}
        </a>
      }
    </div>
  </div>
</icz-card>
